/**
 * Checks if image object has necessary fields
 * @param imageObj
 * @returns
 */
export function isUrlExists(imageObj: Queries.Seo_ComponentBasicAllResolutionsImage|null): boolean {
  if (!imageObj) return false;
  const values = [imageObj.twoX, imageObj.threeX];

  return values.every((item) => {
    if (typeof item === "object" && item !== null) {
      return item.url !== undefined;
    }
    return false;
  });
}
